export const createTodo = (todo) => {
	return (dispatch, getState, { getFirestore }) => {
		const firestore = getFirestore();

		firestore.collection('todos').add({
			...todo,
			createAt: new Date()
		}).then(() => {
			dispatch({ type: 'CREATE_TODO', todo});
		}).catch((err) => {
			dispatch({ type: 'CREATE_TODO_ERROR', err });
		})
	}
}

export const deleteTodo = (todo) => {
	return (dispatch, getState, { getFirestore }) => {
		const firestore = getFirestore();

		firestore.collection('todos').doc(todo).delete()
		.then(() => {
			dispatch({ type: 'DELETE_TODO', todo });
		}).catch((err) => {
			dispatch({ type: 'DELETE_TODO_ERROR', err });
		})
	}
}